export const WrenchIcon = ({
  className,
  width = '24',
  height = '24',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.08789 9.23525C6.48833 8.15024 6.23957 6.90615 6.37579 5.67401C6.51201 4.44187 7.02654 3.28217 7.84864 2.35433C8.67073 1.42649 9.76004 0.776067 10.9668 0.492468C12.1736 0.208869 13.4386 0.306019 14.5879 0.770564L10.8379 4.83463L11.3685 7.304L13.8379 7.83463L17.9019 4.08463C18.3665 5.23394 18.4636 6.49893 18.18 7.7057C17.8964 8.91248 17.246 10.0018 16.3182 10.8239C15.3903 11.646 14.2306 12.1605 12.9985 12.2967C11.7664 12.4329 10.5223 12.1842 9.43726 11.5846L4.18164 17.6784C3.75895 18.1011 3.18566 18.3385 2.58789 18.3385C1.99011 18.3385 1.41683 18.1011 0.994137 17.6784C0.571448 17.2557 0.333984 16.6824 0.333984 16.0846C0.333984 15.4869 0.571448 14.9136 0.994137 14.4909L7.08789 9.23525Z"
        strokeWidth={0.666667}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
